import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable } from 'rxjs';

import { ApiResponse, BaseHttpService, Section } from '@ems/api';
import { CookieService } from 'ngx-cookie-service';
import { HttpCacheManager } from '@ngneat/cashew';

@Injectable({
  providedIn: 'root'
})
export class SectionService extends BaseHttpService {
  override cacheEnabled = false;

  constructor(
    http: HttpClient,
    cookieService: CookieService,
    manager: HttpCacheManager,
  ) {
    super(http, cookieService, manager);
  }

  createSection(data: any): Observable<ApiResponse<Section>> {
    return this.post('sections', data);
  }

  updateSection(id: number, data: any): Observable<ApiResponse<Section>> {
    return this.post('section/' + id, data);
  }

  getAllList(companyId?: number, loader = false): Observable<Section[]> {
    const queryParams = {
      'loader': loader,
      ...(companyId ? { 'filter[company_id][eq]': companyId } : {})
    };

    return this.getAll('sections', queryParams);
  }
}
